"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_1 = require("react");
function useColumns(options) {
    const columns = react_1.useMemo(() => { var _a; return [...((_a = options.columns) !== null && _a !== void 0 ? _a : [])]; }, [options.columns]);
    return columns;
}
exports.useColumns = useColumns;
//# sourceMappingURL=domain-columns.js.map